import React from "react";
import baxfendy from "./assets/baxfendy.png";
import "./ClientSpecific.scss";

const ClientSpecific = ({ client }) => {
  const clientsToRender = ["azbax"];
  const shouldRender = clientsToRender.includes(client);

  const isBAX = client === "azbax";

  return shouldRender ? (
    <div className="ClientSpecific">
      {isBAX ? (
        <div className="bax-message">
          <img src={baxfendy} alt="BAX Fendy" />
          <p>
          At AstraZeneca, we don’t just manage hypertension—we defend against it. <strong>BAXFENDY</strong>, our Dynamic Defender activates a targeted mechanism to deliver control where it matters most, setting a higher bar for care.
          </p>
        </div>
      ) : null}
    </div>
  ) : null;
};

export default ClientSpecific;
